import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="blog-not-found">
        <h1 className="font-fredoka text-4xl" style={{ color: "#2D3055" }}>This note has wandered off.</h1>
        <Link to="/blog" className="btn-terracotta mt-6 inline-flex" data-testid="blog-back-link">
          <ArrowLeft size={16} /> Back to Blog
        </Link>
      </div>
    );
  }

  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24 font-nunito" style={{ color: "#7E82A1" }}>Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 py-14" data-testid="blog-detail-page">
      <Link to="/blog" className="inline-flex items-center gap-1 font-fredoka text-sm mb-6" style={{ color: "#6EC4E8" }} data-testid="blog-back-link">
        <ArrowLeft size={16} /> Back to notes
      </Link>
      <p className="font-caveat text-2xl" style={{ color: "#FF6B9D" }}>
        {new Date(post.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
      </p>
      <h1 className="font-fredoka text-4xl sm:text-5xl mt-2 leading-tight" style={{ color: "#2D3055" }}>{post.title}</h1>

      {post.cover_image_url && (
        <img src={post.cover_image_url} alt={post.title} className="w-full h-[380px] object-cover rounded-3xl mt-8" />
      )}

      <div className="mt-8 prose-warm font-nunito text-lg">
        {post.content.split("\n\n").map((para, i) => <p key={i}>{para}</p>)}
      </div>
    </article>
  );
}
